import { render, staticRenderFns } from "./TextUnfold.vue?vue&type=template&id=63d6459e&scoped=true"
import script from "./TextUnfold.vue?vue&type=script&lang=js"
export * from "./TextUnfold.vue?vue&type=script&lang=js"
import style0 from "./TextUnfold.vue?vue&type=style&index=0&id=63d6459e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d6459e",
  null
  
)

export default component.exports